import React, { Component } from 'react';
import '../assets/custom.css';
import '../assets/teachers.css';
import Select from 'react-select';
import {Redirect, withRouter} from 'react-router-dom';

import HeaderComponent from '../Shared/Header';
import REST from '../Shared/REST';
import ico_plus_green from '../assets/images/ico_plus_green.png';
import ico_view from '../assets/images/ico_view.png';
import FooterComponent from "../Shared/Footer";
import DialogBox from "../Shared/DialogBox";
import DeleteDialogBox from "../Shared/DeleteDialogBox";
import ReactDOM from "react-dom";
import TRACKING from "../Shared/DataTrackingPoints";
import {selectClass, selectSchool, selectTeacher, updateStudent, updateTeacher, userLogout} from "../TeachersComponent/actions";
import {connect} from "react-redux";
import {Overlay, Popover} from "react-bootstrap";
import {GamePerformaceComponent} from "../TeachersComponent/Main";

let addClassInstruction = null;
let addStudentInstruction = null;
let addStudentStorage = localStorage.getItem('addStudent');
let samplingStrategyOptions = [];


const readingLevelOptions = [
    { value: '0', label: 'Above grade level' },
    { value: '1', label: 'At grade level' },
    { value: '2', label: 'Below grade level' },
    { value: '3', label: 'Unknown' }
];

const genderOptions = [
    { value: '1', label: 'Female' },
    { value: '2', label: 'Male' },
    { value: '3', label: 'Other' }
];

const raceOptions = [
    { value: '1', label: 'American Indian' },
    { value: '2', label: 'Asian' },
    { value: '3', label: 'Black or African American' },
    { value: '4', label: 'Native Hawaiian or Other Pacific Islander' },
    { value: '5', label: 'Caucasian (Hispanic or Latino)' },
    { value: '6', label: 'Caucasian (Not Hispanic or Latino)' },
    { value: '7', label: 'Unkown' }
];

const gradeOptions = [

    { value: '3', label: '3' },
    { value: '4', label: '4' },
    { value: '5', label: '5' },
    { value: '6', label: '6' },
    { value: '7', label: '7' },
    { value: '8', label: '8' },
    { value: '9', label: '9' },
    { value: '10', label: '10' },
    { value: '11', label: '11' },
    { value: '12', label: '12' },
    { value: 'Transition', label: 'Transition' },
    { value: 'College', label: 'College' }

];

const fourValueOptions = [
    { value: '0', label: 'No' },
    { value: '1', label: 'Yes' },
    { value: '2', label: 'Unknown' }

];

let participantGroupOptions = [
    {value: '1', label: 'Base group'},
    {value: '9', label: 'BaseG2: Skip Training Camp'},
    {value: '2', label: 'S1G1: No Training Camp'},
    {value: '3', label: 'S1G2: Training Camp'},
    {value: '4', label: 'S1G3: Training Camp with Prompts'},
    {value: '5', label: 'S2G1: Free Form Highlights'},
    {value: '6', label: 'S2G2: SRL Highlighting'},
    {value: '7', label: 'S3G1: Delayed Monitoring'},
    {value: '8', label: 'S3G2: Instant Monitoring'},
    {value: '10', label: 'S4G1: No Moment of Truth'},
    {value: '11', label: 'S5G1: Reduced Training Camp '},
    {value: '12', label: 'S6G1: No judgment '},
    {value: '13', label: 'S6G2: No feedback '},
    {value: '14', label: 'S6G3: Generic Feedback '},
    {value: '15', label: 'S6G4: Customized Feedback '},
    {value: '16', label: 'S7G1: No Training Camp & Instant Monitoring'}
];


let getValue = (opts, val) => opts.find(o => o.value === val);
let getFourValue = (opts, val) => {
    if (val === '-1') return null;
    else opts.find(o => o.value === val);
}

class SchoolAdminComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            researcher: this.props.schoolAdmin&&this.props.schoolAdmin.schooladmin&&this.props.schoolAdmin.schooladmin.researcher?true:false,
            teachers: [],
            teacherToEdit: {},
            addTeacher: false,
            editTeacher: false,
            addStudent: false,
            addClass: false,
            editClass: false,
            classes: [],
            class: {},
            classStudents: [],
            student: {},
            samplingStrategies: [],
            clickedClassId:-1,
            clickedTeacherId:-1,
            modalDialog: false,
            responseContent:'',
            schoolOptions: '',
            schoolValue: ''
        };
        this.handleAddTeacher = this.handleAddTeacher.bind(this);
        this.handleAddClass = this.handleAddClass.bind(this);
        this.handleDeleteClass = this.handleDeleteClass.bind(this);

        this.handleClassEditClick = this.handleClassEditClick.bind(this);
        this.handleDeleteStudent = this.handleDeleteStudent.bind(this);
    }

    async componentDidMount() {
        await REST.listSamplingStrategies().then(async(results) => {
            if (results.success) {
                samplingStrategyOptions = [];
                let samplingStrategies = results.body;
                for (let samplingStrategy of samplingStrategies) {
                    samplingStrategyOptions.push({value: samplingStrategy.id, label: samplingStrategy.name});
                }
                await this.setState({
                    samplingStrategyOptions: samplingStrategyOptions
                });
            } else {
                console.log('Error', results.msg);
            }
        }, (error) => {
            console.log('Error', error.msg);
        });
        let selectedSchool;
        if(this.props.lastSchool){
            selectedSchool = this.props.lastSchool;
        }else{
            selectedSchool = -1; //by default = 0
        }
        await this.handleSchoolChange(selectedSchool);
        let lastTeacher = this.props.lastTeacher;
        let selectTeacher = this.handleTeacherItemClick;
        if(lastTeacher){
            setTimeout(async function () {
                await selectTeacher(lastTeacher);
            }, 100);
            let lastClass = this.props.lastClass;
            let selectClass = this.handleClassItemClick;
            if(lastClass){
                setTimeout(async function () {
                    selectClass(lastClass);
                }, 100);
                if(this.props.lastStudent){
                    this.handleStudentClick(this.props.lastStudent,this.props.lastClass.id)
                }
            }
        }
    }

    handleAnalytics(){
        let analytics = this.state.analytics;
        REST.addAnalytics(analytics).then(res => {});
    }

    handleSchoolLoaded =  async (schools) =>{
        await this.setState({schoolOptions: schools});
    }

    handleSchoolChange = async (newValue) => {
        REST.listTeachersInSchool(newValue).then(async (response) => {
            if (response.success) {
                this.setTeachers(response.body);
                await this.setState({
                    classes: [],
                    classStudents:[],
                    addTeacher: false,
                    editTeacher: false
                });
            }
            else {
                console.log('Error', response.msg);
            }
        }, (error) => {
            console.log('Error', error.msg);
        });
    };

    setTeachers = (object) => {
        this.setState({ teachers: object });
    }

    handleAddTeacher(event) {
        this.setState({ addTeacher: !this.state.addTeacher, editTeacher: false });
    }

    handleCancel = () => {
        this.setState({ addTeacher: false, editTeacher: false, addStudent:false, addClass:false, editClass:false});
    }

    handleTeacherEditClick = (object) => {
        this.setState({ addTeacher: false, editTeacher: true, teacherToEdit: null });
        this.handleAddTeacher();
        this.setState({ addTeacher: false, editTeacher: true, teacherToEdit: object });
    }

    handleTeacherItemClick = async (object) => {
        this.setState({
            addTeacher: false,
            editTeacher: false,
            addClass:false,
            editClass:false,
            addStudent:false,
            showClass: true,
            clickedTeacherId:object.id,
            classStudents: []
        });
        await this.listClasses(object.id);
        await this.props.updateTeacher(object);
        await this.props.selectTeacher(object);
    }

    handleAddClass() {
        this.setState({ showClass: false, addClass: true, editClass: false, showStudent: false, newStudent: false });
    }

    handleNewClassCallback = (classObject) => {
        let classes = this.state.classes;
        classes.push(classObject);
        this.setState({ classes: classes });
        this.handleClassItemClick(classes[classes.length-1]);
        this.setState({
                analytics: {
                    type: TRACKING.TEACHER_ADDED_CLASS,
                    metadata: {classId: classObject.id, className: classObject.name},
                }
            },
            ()=>this.handleAnalytics())
    };

    handleUpdateClass = (object) => {
        this.handleCancel();
        this.setState({
                analytics: {
                    type: TRACKING.TEACHER_UPDATED_CLASS,
                    metadata: {classId: object.id, className: object.name},
                }
            },
            ()=>this.handleAnalytics())
        this.setState({ classes: [] });
        this.listClasses();
    };

    handleDeleteClass(theclass){
        REST.deleteClass(theclass.id).then(async res => {
            await this.handleCancel();
            await this.listClasses();
        });
    }

    listClasses(teacherId) {
        REST.teacherClassList(teacherId).then((response) => {
            if (response.success) {
                this.setState({ classes: response.body });
                console.log(response.body);
            }
            else {
                this.setState({
                    modalDialog: true,
                    responseContent:response.msg

                });
                setTimeout(()=>{this.setState({modalDialog:false})},3500);
            }
        }, (error) => {
            this.setState({
                modalDialog: true,
                responseContent:error.msg

            });
            setTimeout(()=>{this.setState({modalDialog:false})},3500);
        });
    }

    handleClassItemClick = (object) => {
        this.handleCancel();
        REST.listStudents(object.id).then(async (response) => {
            if (response.success) {
                let res = response.body;
                await this.setState({ classStudents: res, class: object, clickedClassId:object.id });
                await this.props.selectClass(object);
            } else {
                this.setState({
                    modalDialog: true,
                    responseContent:response.msg

                });
                setTimeout(()=>{this.setState({modalDialog:false})},3500);
            }
        }, (error) => {
            console.log('Error', error.msg);
        });
    };

    handleClassEditClick(object) {
        this.setState({ class:object, clickedClassId:object.id, showClass: false, editClass: true, addClass: false, showStudent: false, addStudent: false });
    }


    handleStudentClick = (student, classId) => {
        this.props.handleStudentClick(student, classId);
        this.props.updateStudent(student);
        this.props.history.push('/teacher/student');
    };

    handleDeleteStudent(student){
        REST.deleteStudent(student.userId, this.state.clickedTeacherId, this.props.lastClass.id).then(res => {
            this.handleClassItemClick(this.props.lastClass);
            this.setState({
                    analytics: {
                        type: TRACKING.TEACHER_STUDENT_DELETE,
                        metadata: {userId: student.user.id, firstName: student.user.firstname, lastName: student.user.lastname},
                    }
                },
                ()=>this.handleAnalytics())
        });
    }

    handleLogout = () => {
        REST.logout().then(async (response) => {
            await this.props.selectSchool(null);
            if(localStorage.getItem('addClass') === 'hide'){
                addClassInstruction = localStorage.getItem('addClass');
            }
            if(localStorage.getItem('addStudent') === 'hide'){
                addStudentInstruction = localStorage.getItem('addStudent');
            }
            localStorage.removeItem('token');
            if(addClassInstruction !== null){
                localStorage.setItem('addClass',addClassInstruction);
            }
            if(addStudentInstruction !== null){
                localStorage.setItem('addStudent',addStudentInstruction);
            }
            this.props.history.push("/login");
        }, (error) => {
            localStorage.removeItem('token');
            localStorage.clear();
            this.props.history.push("/login");
        });
    }

    teacherAdded = () => {
        window.location.reload();
    }

    teacherDeleted = async () => {
        await this.props.updateTeacher(null);
        await this.props.selectTeacher(null);
        window.location.reload();
    }

    handleAddStudent = (classId) => {
        this.setState({ addStudent: true, editClass:false, addClass: false, showClass: false });
    };

    render() {
        return (
            <div>
                <HeaderComponent schoolAdmin={this.props.schoolAdmin} changeSchool={this.handleSchoolChange} schoolLoaded={this.handleSchoolLoaded} logout={this.handleLogout} />
                <div className="section bgGrey">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-3">
                                <div className={"row"}>
                                    <div className={"col-md-10"}>
                                        <h1 className="fl">Teachers</h1>
                                    </div>
                                    <div className={"col-md-2"}>
                                        {this.state.schoolOptions?
                                        <a className="fr">
                                            <img src={ico_plus_green} onClick={this.handleAddTeacher} alt="Plus Icon" border="0" className="ico-xs ico-add" />
                                        </a>
                                            :null}
                                    </div>
                                </div>
                                <div className="col-lg-12 col-md-12 solidBorder noPadding scrollable" style={{maxHeight:450, height:450}}>
                                    <TeachersListComponent
                                        teachers={this.state.teachers}
                                        handleItemClick={this.handleTeacherItemClick}
                                        handleEditClick={this.handleTeacherEditClick}
                                        clickedTeacherID={this.state.clickedTeacherId}
                                    />
                                </div>
                            </div>
                            {this.state.showClass && !this.state.editTeacher && !this.state.addTeacher?
                                <div className="col-md-3">
                                    <div className={"col-md-10"}>
                                        <h1 className="fl">Classes</h1>
                                    </div>
                                    {this.props.schoolAdmin&&this.props.schoolAdmin.schooladmin&&this.props.schoolAdmin.schooladmin.researcher ?
                                        <div className={'col-md-2'}>
                                            <a ref={button => {
                                                this.target = button;
                                            }} className="fr">
                                                <img src={ico_plus_green} onClick={this.handleAddClass} alt="Plus Icon"
                                                     border="0" className="ico-xs ico-add"/>
                                            </a>
                                        </div>:null
                                    }
                                    <div className="col-lg-12 col-md-12 solidBorder noPadding scrollable" style={{maxHeight:450, height:450}}>
                                        <ClassListComponent
                                            classes={this.state.classes}
                                            researcher = {this.props.schoolAdmin.schooladmin.researcher}
                                            handleItemClick={this.handleClassItemClick}
                                            handleEditClick={this.handleClassEditClick}
                                            clickedClassID={this.state.clickedClassId}
                                        />
                                    </div>
                                </div>:null}
                            {this.state.showClass && !this.state.editTeacher && !this.state.addTeacher?
                                <div className="col-md-6">
                                    <ClassNavigation
                                        class={this.state.class}
                                        students={this.state.classStudents}
                                        researcher={this.props.schoolAdmin.schooladmin.researcher}
                                        handleAddStudent={this.handleAddStudent}
                                        studentClick={this.handleStudentClick}
                                        updateClassCallback={this.handleUpdateClass}
                                        deleteStudent={this.handleDeleteStudent}
                                    />
                                </div>:null}

                            {this.state.addTeacher ?
                                <div className="col-md-9 container navbar-container">
                                    <AddTeacherComponent handleTeacherAdded={this.teacherAdded} schoolOptions = {this.state.schoolOptions} schoolValue = {this.props.lastSchool} samplingStrategyOptions = {this.state.samplingStrategyOptions} researcher={this.state.researcher} handleCancel={this.handleCancel} />
                                </div> : null}
                            {this.state.editTeacher ?
                                <div className="col-md-9 container navbar-container">
                                    <UpdateTeacherComponent handleTeacherUpdated={this.teacherAdded} handleTeacherDeleted={this.teacherDeleted} teacher={this.state.teacherToEdit} schoolOptions = {this.state.schoolOptions} schoolValue = {this.props.lastSchool} samplingStrategyOptions = {this.state.samplingStrategyOptions} researcher={this.state.researcher} handleCancel={this.handleCancel} />
                                </div> : null}
                            {
                                this.state.addClass ? (
                                        <div className="col-md-9 container navbar-container">
                                            <h1>Add Class</h1>
                                            <AddClassComponent edit={false} teacherId={this.state.clickedTeacherId} cancelCallback={this.handleCancel} saveClassCallback={this.handleNewClassCallback} />
                                        </div>)
                                    :
                                    null
                            }
                            {
                                this.state.editClass ? (
                                        <div className="col-md-9 container navbar-container">
                                            <h1>Edit Class</h1>
                                            <AddClassComponent edit={true} teacherId={this.state.clickedTeacherId} class={this.state.class} cancelCallback={this.handleCancel} saveClassCallback={this.handleUpdateClass} />
                                        </div>)
                                    :
                                    null
                            }
                            {
                                this.state.addStudent ?
                                    <AddStudent class={this.state.class} teacherId={this.props.teacher.userId} classId={this.state.class.id} samplingStrategyId={this.props.teacher.samplingStrategyId} handleCancel={this.handleCancel} handleClassItemClick={this.handleClassItemClick} researcher={this.state.researcher} participantGroupOptions = {participantGroupOptions}/>
                                    :
                                    null
                            }
                        </div>
                    </div>
                </div>
                <FooterComponent/>
            </div>
        );
    }
}

const getSchoolSamplingStrategy = (opts, val) => opts.find(o => o.value == val);

class AddTeacherComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            firstname: '',
            lastname: '',
            username: '',
            email: '',
            schoolId: this.props.schoolValue,
            samplingStrategyId: getSchoolSamplingStrategy(this.props.schoolOptions, this.props.schoolValue).samplingStrategyId,
            inProject: true,
            modalDialog:false,
            responseContent:'' };
        this.handleName = this.handleName.bind(this);
        this.handleLastName = this.handleLastName.bind(this);
        this.handleUserName = this.handleUserName.bind(this);
        this.handleEmail = this.handleEmail.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleSave = this.handleSave.bind(this);
    }

    handleName(event) {
        this.setState({ firstname: event.target.value });
        event.preventDefault();
    }

    handleLastName(event) {
        this.setState({ lastname: event.target.value });
        event.preventDefault();
    }

    handleUserName(event) {
        this.setState({ username: event.target.value });
        event.preventDefault();
    }

    handleEmail(event) {
        this.setState({ email: event.target.value });
        event.preventDefault();
    }

    handleCancel(event) {
        this.props.handleCancel();
    }

    handleSave(event) {
        REST.createTeacher(this.state).then((response) => {
            if (response.success) {
                this.setState({
                    modalDialog: true,
                    responseContent: 'Teacher Successfully Added!'
                });
                setTimeout(()=>{this.setState({modalDialog:false}); this.props.handleCancel(); this.props.handleTeacherAdded();},3500);
                this.myFormRef.reset();
            }
            else {
                this.setState({
                    modalDialog: true,
                    responseContent:response.msg
                });
                setTimeout(()=>{this.setState({modalDialog:false})},3500);
            }
        }, (error) => {
            this.setState({
                modalDialog: true,
                responseContent:error.msg
            });
            setTimeout(()=>{this.setState({modalDialog:false})},3500);
        });
    }

    render() {
        return (
            <div className="col-lg-12 solidBorder hasfitWidth">
                <DialogBox notificationModal modalOpen={this.state.modalDialog} sectionContent={this.state.responseContent} closeClick={(active)=>{this.setState({modalDialog: active});}} />
                <form id="formAddTeacher" ref={(el) => this.myFormRef = el}>
                    <label htmlFor="inputTeacherName">First Name</label>
                    <input type="text" onChange={this.handleName} id="inputTeacherName" className="form-control" placeholder="First Name" required autoFocus />
                    <label htmlFor="inputTeacherLastName">Last Name</label>
                    <input type="text" onChange={this.handleLastName} id="inputTeacherLastName" className="form-control" placeholder="Last Name" required />
                    <label htmlFor="inputStudentUsername">User Name</label>
                    <input type="text" defaultValue={this.state.username} onChange={this.handleUserName} id="inputStudentUsername" className="form-control" placeholder="User Name"/>
                    <label htmlFor="inputTeacherEmail">Email</label>
                    <input type="text" onChange={this.handleEmail} id="inputTeacherEmail" className="form-control" placeholder="Email" required />
                    <label htmlFor="inputTeacherEmail">School</label>
                    <div style={{width:'68%'}}>
                        <Select
                            id={"addTeacherSchool"}
                            onChange={(newValue)=>{
                                this.setState({ schoolId: newValue.value});
                                //this.setState({ samplingStrategyId: getSchoolSamplingStrategy(this.props.schoolOptions, newValue.value).samplingStrategyId});
                            }}
                            options={this.props.schoolOptions}
                            placeholder = {"Select a school..."}
                            value={getValue(this.props.schoolOptions, this.props.schoolValue)}

                        />
                    </div>
                    {this.props.researcher?
                        <div>
                            <br/>
                            <label htmlFor="inputTeacherSamplingStrategy">Sampling Strategy</label>
                            <div style={{width:'68%'}}>
                                <Select
                                    id={"updateTeacherSamplingStrategy"}
                                    onChange={(newValue)=>{this.setState({ samplingStrategyId: newValue.value})}}
                                    options={this.props.samplingStrategyOptions}
                                    placeholder = {"Select a sampling strategy..."}
                                    value={getValue(this.props.samplingStrategyOptions, this.state.samplingStrategyId)}
                                />
                            </div>
                        </div>
                        :null}
                </form>
                <div className="nav navbar fr" style={{marginTop:30}}>
                    <a onClick={this.handleCancel} className="handBtn">
                        <span>Cancel</span>
                    </a>
                    <a onClick={this.handleSave} className="handBtn">
                        <span>Save Changes</span>
                    </a>
                </div>
            </div>
        );
    }
}

class UpdateTeacherComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            firstname: this.props.teacher.user.firstname,
            lastname: this.props.teacher.user.lastname,
            email: this.props.teacher.user.email,
            inProject: true,
            userId: this.props.teacher.userId,
            username: this.props.teacher.user.username,
            researcher: this.props.teacher.researcher,
            schoolId: this.props.schoolValue,
            samplingStrategyId: this.props.teacher.samplingStrategyId,
            modalDialog:false,
            modalDialogDelete:false
        };
        this.handleName = this.handleName.bind(this);
        this.handleLastName = this.handleLastName.bind(this);
        this.handleEmail = this.handleEmail.bind(this);
        this.handleUserName = this.handleUserName.bind(this);
        this.handleReseacher = this.handleReseacher.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.deleteTeacher = this.deleteTeacher.bind(this);
    }

    componentDidUpdate(oldProps){
        const newProps = this.props;
        if(oldProps.teacher.userId !== newProps.teacher.userId){
            this.setState({
                firstname: this.props.teacher.user.firstname,
                lastname: this.props.teacher.user.lastname,
                email: this.props.teacher.user.email,
                schoolId: this.props.schoolValue,
                samplingStrategyId: this.props.teacher.samplingStrategyId,
                username: this.props.teacher.user.username,
                researcher: this.props.teacher.researcher,
                modalDialog:false,
                modalDialogDelete:false });
        }
    }

    deleteTeacher = (confirm) =>{
        if(confirm) {
            this.handleDelete();
        }
        this.setState({
            modalDialogDelete:false,
        });
    }

    handleName(event) {
        this.setState({ firstname: event.target.value.replace(/\s+/g, '') });
        event.preventDefault();
    }

    handleLastName(event) {
        this.setState({ lastname: event.target.value.replace(/\s+/g, '') });
        event.preventDefault();
    }

    handleEmail(event) {
        this.setState({ email: event.target.value });
        event.preventDefault();
    }

    handleUserName(event) {
        this.setState({ username: event.target.value });
        event.preventDefault();
    }

    handleReseacher(event) {
        this.setState({ researcher: !this.state.researcher });
        // event.preventDefault();
    }

    handleCancel(event) {
        this.props.handleCancel();
        event.preventDefault();
    }

    handleSave(event) {
        REST.updateTeacher(this.state).then((response) => {
            if (response.success) {
                this.setState({
                    modalDialog: true,
                    responseContent:'Teacher Data Successfully Updated!'
                });
                setTimeout(()=>{this.setState({modalDialog:false})},3500);
                this.props.handleTeacherUpdated();
            }
            else {
                alert(response.msg);
            }
        }, (error) => {
            alert(error.msg);
        });
        event.preventDefault();
    }

    handleDelete(event) {
        REST.deleteTeacher(this.state.userId).then((response) => {
            if (response.success) {
                this.setState({
                    modalDialog: true,
                    responseContent:'Teacher Successfully Deleted!'
                });
                setTimeout(()=>{this.setState({modalDialog:false}); this.props.handleCancel();this.props.handleTeacherDeleted();},3500);
            }
            else {
                alert(response.msg);
            }
        }, (error) => {
            alert(error.msg);
        });
    }

    render() {
        return (
            <div className="col-lg-12 solidBorder hasfitWidth">
                <DialogBox notificationModal modalOpen={this.state.modalDialog} sectionContent={this.state.responseContent} closeClick={(active)=>{this.setState({modalDialog: active});}} />
                <DeleteDialogBox
                    confirmDelete={this.deleteTeacher}
                    modalOpen={this.state.modalDialogDelete}
                    sectionContent={this.state.responseContent}
                    closeClick={(active)=>{this.setState({modalDialog: active});}} />
                <form>
                    <label htmlFor="inputTeacherName">First Name</label>
                    <input type="text" value={this.state.firstname} onChange={this.handleName} id="inputTeacherName" className="form-control" placeholder="First Name" required autoFocus />
                    <label htmlFor="inputTeacherLastName">Last Name</label>
                    <input type="text" value={this.state.lastname} onChange={this.handleLastName} id="inputTeacherLastName" className="form-control" placeholder="Last Name" required />
                    {/*<label htmlFor="inputTeacherEmail">Email</label>*/}
                    {/*<input type="text" onChange={this.handleEmail} id="inputTeacherEmail" value={this.state.email} className="form-control" placeholder="Email" required />*/}
                    <label htmlFor="inputTeacherUserName">User Name</label>
                    <input type="text" value={this.state.username} onChange={this.handleUserName} id="inputTeacherUserName" className="form-control" placeholder="User Name" required />
                    <label htmlFor="inputTeacherEmail">School</label>
                    <div style={{width:'68%'}}>
                        <Select
                            id={"updateTeacherSchool"}
                            onChange={(newValue)=>{this.setState({ schoolId: newValue.value, samplingStrategyId: getSchoolSamplingStrategy(this.props.schoolOptions, newValue.value).samplingStrategyId})}}
                            options={this.props.schoolOptions}
                            placeholder = {"Select a school..."}
                            value={getValue(this.props.schoolOptions, this.state.schoolId)}
                        />
                    </div>

                    {this.props.researcher?
                        <div>
                            <br/>
                            <label htmlFor="inputTeacherSamplingStrategy">Sampling Strategy</label>
                            <div style={{width:'68%'}}>
                                <Select
                                    id={"updateTeacherSamplingStrategy"}
                                    onChange={(newValue)=>{this.setState({ samplingStrategyId: newValue.value})}}
                                    options={this.props.samplingStrategyOptions}
                                    placeholder = {"Select a sampling strategy..."}
                                    value={getValue(this.props.samplingStrategyOptions, this.state.samplingStrategyId)}
                                />
                            </div>
                        </div>
                    :null}
                    <label style={{width:'30%'}}> </label>
                    <div style={{display:'inline-block', position:'relative', width:'70%'}}>
                        <label htmlFor="cbResearcher" className="cb "><input type="checkbox" onChange={this.handleReseacher} name="researcher" checked={this.state.researcher} id="cbResearcher" /><span className="checkmark"></span> Researcher</label>
                    </div><br />
                </form>
                <div className="nav navbar fl">
                    <a onClick={(event)=>{this.setState({modalDialogDelete:true,responseContent:'ARE YOU SURE YOU WANT TO DELETE THIS TEACHER?'});   event.stopPropagation();}} className="handBtn">
                        <span>Delete Teacher</span>
                    </a>
                </div>
                <div className="nav navbar fr">
                    <a onClick={this.handleCancel} className="handBtn">
                        <span>Cancel</span>
                    </a>
                    <a onClick={this.handleSave} className="handBtn">
                        <span>Save Changes</span>
                    </a>
                </div>
            </div>
        );
    }
}

class TeachersListComponent extends Component {
    handleItemClick = (object) => {
        this.props.handleItemClick(object);
    }

    handleEditClick = (object) => {
        this.props.handleEditClick(object);
    }

    render() {
        let items = this.props.teachers;
        const teachers = items.map((item) => {
            if (item.user) {
                return <TeachersListItemComponent key={item.id} item={item} active={this.props.clickedTeacherID===item.id ? "active":""} handleClick={this.handleItemClick} handleEditClick={this.handleEditClick}/>
            }
            else return null;
        });
        return (
            <table cellPadding="0" cellSpacing="0" border="0" width="100%">
                <tbody>
                {teachers}
                </tbody>
            </table>
        );
    }
}

class TeachersListItemComponent extends Component {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
        this.handleEditClick = this.handleEditClick.bind(this);
    }

    handleClick(event) {
        this.props.handleClick(this.props.item);
        event.preventDefault();
    }

    handleEditClick(event) {
        this.props.handleEditClick(this.props.item);
        event.preventDefault();
    }

    render() {
        return (
            <tr className={"clickable-row "+this.props.active}>
                <td onClick={this.handleClick} >{this.props.item.user.lastname}, {this.props.item.user.firstname}  </td>
                <td className="fitWidth">
                    <a>
                        <img onClick={this.handleEditClick} src={ico_view} alt="View Icon" border="0" className="ico-xs" />
                    </a>
                </td>
            </tr>
        );
    }
}

class ClassListComponent extends Component {

    handleItemClick = (object) => {
        this.props.handleItemClick(object);
    };

    handleEditClick = (object) => {
        this.props.handleEditClick(object);
    };

    render() {
        let items = this.props.classes;
        const classes = items.map((item) => {
            return <ClassItemComponent key={item.id} item={item} researcher={this.props.researcher} active={this.props.clickedClassID===item.id ? "active":""} handleClick={this.handleItemClick} handleEditClick={this.handleEditClick} deleteClass={this.props.deleteClass}/>
        });
        return (
            <table cellPadding="0" cellSpacing="0" border="0" width="100%">
                <tbody>
                {classes}
                </tbody>
            </table>
        );
    }
}

class ClassItemComponent extends Component {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
        this.handleEditClick = this.handleEditClick.bind(this);
        this.deleteClass = this.deleteClass.bind(this);
    }

    handleClick(event) {
        this.props.handleClick(this.props.item);
        event.preventDefault();
    }

    handleEditClick(event) {
        this.props.handleEditClick(this.props.item);
        event.preventDefault();
    }

    deleteClass(event){
        let confirmed = window.confirm("Are you sure that you want to delete this class ?");
        if(confirmed) {
            this.props.deleteClass(this.props.item);
        }
        event.stopPropagation();
    }

    render() {
        return (
            <tr className={"clickable-row "+this.props.active} >
                <td onClick={this.handleClick}>{this.props.item.name}</td>
                {this.props.researcher?
                    <td className="fitWidth" onClick={this.handleEditClick}>
                        <a>
                            <img src={ico_view} alt="View Icon" border="0" className="ico-xs" />
                        </a>
                    </td>
                    :null}
            </tr>
        );
    }
}


class AddClassComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            name: this.props.class ? this.props.class.name : "", confirmDelete:false
        };
        this.handleName = this.handleName.bind(this);
        this.handleGrade = this.handleGrade.bind(this);
        this.handleSemester = this.handleSemester.bind(this);
        this.handleYear = this.handleYear.bind(this);

        this.handleSave = this.handleSave.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.deleteClass = this.deleteClass.bind(this);
        this.handleAnalytics = this.handleAnalytics.bind(this);

    }

    handleAnalytics(){
        let analytics = this.state.analytics;
        REST.addAnalytics(analytics).then(res => {});
    }

    handleName(event) {
        this.setState({ name: event.target.value });
    }

    handleGrade(event) {
        this.setState({ grade: event.target.value });
    }

    handleSemester(event) {
        this.setState({ semester: event.target.value });
    }

    handleYear(event) {
        this.setState({ year: event.target.value });
    }

    handleSave(event) {
        if (!this.state.name) {
            this.setState({
                modalDialog: true,
                responseContent:'Must enter class name'

            });
            setTimeout(()=>{this.setState({modalDialog:false})},3500);
            return;
        }
        if (this.props.edit) {
            let body = { classId: this.props.class.id, name: this.state.name };
            REST.updateClass(this.props.teacherId, body).then((response) => {
                if (response.success) {
                    this.props.saveClassCallback(response.body);
                } else {
                    this.setState({
                        modalDialog: true,
                        responseContent:response.msg

                    });
                    setTimeout(()=>{this.setState({modalDialog:false})},3500);
                }
            }, (error) => {
                console.log('Add new class error', error);
                this.setState({
                    modalDialog: true,
                    responseContent:error.msg

                });
                setTimeout(()=>{this.setState({modalDialog:false})},3500);
            });
        }
        else {
            let body = { name: this.state.name };
            REST.addNewClass(this.props.teacherId, body).then((response) => {
                if (response.success) {
                    this.props.saveClassCallback(response.body);
                } else {
                    this.setState({
                        modalDialog: true,
                        responseContent:response.msg

                    });
                    setTimeout(()=>{this.setState({modalDialog:false})},3500);
                }
            }, (error) => {
                console.log('Add new class error', error);
                this.setState({
                    modalDialog: true,
                    responseContent:error.msg

                });
                setTimeout(()=>{this.setState({modalDialog:false})},3500);
            });
        }
        event.preventDefault();
    }

    handleCancel() {
        this.props.cancelCallback();
    }

    handleDelete() {
        REST.deleteClass(this.props.class.id).then((response) => {
            if (response.success) {
                this.setState({
                        analytics: {
                            type: TRACKING.TEACHER_DELETED_CLASS,
                            metadata: {classId: this.props.class.id},
                        }
                    },
                    ()=>this.handleAnalytics())
                this.props.saveClassCallback(response.body);
            }
            else {
                this.setState({
                    modalDialog: true,
                    responseContent:response.msg

                });

                setTimeout(()=>{this.setState({modalDialog:false})},3500);
            }
        }, (error) => {
            console.log('Delete class error', error);
        });
    }

    deleteClass = (confirm) => {
        if(confirm){
            this.handleDelete();
        }
    }

    render() {
        return (
            <div className="col-lg-12 solidBorder hasfitWidth"><DialogBox notificationModal modalOpen={this.state.modalDialog} sectionContent={this.state.responseContent} closeClick={(active)=>{this.setState({modalDialog: active});}} />
                <form id="formAddClass">
                    <label htmlFor="inputClassName">Class Name</label>
                    <input type="text" onChange={this.handleName} id="inputClassName" value={this.state.name} className="form-control" placeholder="Class Name" required autoFocus />
                </form>
                <hr/>
                {!this.props.edit ?
                    (<div className="nav navbar fr">
                        <a onClick={this.handleCancel} className="handBtn">
                            <span>Cancel</span>
                        </a>
                        <a onClick={this.handleSave} className="handBtn">
                            <span>Save Changes</span>
                        </a>
                    </div>) :
                    (<div className="nav navbar fr">
                        <DialogBox
                            modalOpen={this.state.modalDialog}
                            confirmDelete={this.deleteClass}
                            sectionContent={this.state.responseContent}
                            closeClick={(active)=>{this.setState({modalDialog: active});}}
                        />
                        <a onClick={()=>{this.setState({modalDialog:true,responseContent:'ARE YOU SURE YOU WANT TO DELETE THIS CLASS?'})}} className="handBtn">
                            <span>Delete Class</span>
                        </a>
                        <a onClick={this.handleCancel} className="handBtn">
                            <span>Cancel</span>
                        </a>
                        <a onClick={this.handleSave} className="handBtn">
                            <span>Save Changes</span>
                        </a>
                    </div>)}

            </div>
        );
    }
}

class ClassNavigation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            class: this.props.class,
            listStudents: true,
            showPerformance:false,
        };
        this.handleStudentsTab = this.handleStudentsTab.bind(this);
        this.handlePerformanceTab = this.handlePerformanceTab.bind(this);
        this.handleClassTab = this.handleClassTab.bind(this);
    }

    componentDidMount() {
        this.setState({class:this.props.class});
    }

    componentDidUpdate(oldProps){
        const newProps = this.props;
        if(oldProps.class.id !== newProps.class.id) {
            this.setState({class:this.props.class});
        }
    }



    handleStudentClick = (student, classId) => {
        this.props.studentClick(student, classId);
    }

    handleAddStudent = () => {
        this.props.handleAddStudent(this.state.class.id);
    }

    handlePerformanceTab(event) {
        this.setState({ listStudents: false, showPerformance:true });
        event.preventDefault();
    }

    handleStudentsTab(event) {
        this.setState({ listStudents: true, showPerformance:false });
        event.preventDefault();
    }

    handleClassTab(event) {
        this.setState({ listStudents: false });
        // event.preventDefault();
    }

    handleCancel = () => {
        this.setState({ listStudents: true });
    }

    handleUpdateClass = (object) => {
        this.props.updateClassCallback(object);
    }

    listStudents() {
        REST.listStudents(this.props.class.id).then((response) => {
            if (response.success) {
                this.setState({ students: response.body });
            }
            else {
                this.setState({
                    modalDialog: true,
                    responseContent:response.msg

                });
                setTimeout(()=>{this.setState({modalDialog:false})},3500);
            }
        }, (error) => {
            console.log('List students error', error);
            this.setState({
                modalDialog: true,
                responseContent:error.msg

            });
            setTimeout(()=>{this.setState({modalDialog:false})},3500);
        });
    }

    render() {
        return (
            <div className="col-md-12">
                {this.state.listStudents ?
                    (<div>
                        <ul className="nav nav-tabs">
                            <li className="active"  onClick={this.handleStudentsTab}><a data-toggle="tab">Students</a></li>
                            <li onClick={this.handlePerformanceTab}><a data-toggle="tab">Game Performance</a></li>
                        </ul>
                            <div className="tab-content">
                                <StudentsList
                                    classId={this.state.class.id}
                                    students={this.props.students}
                                    researcher={this.props.researcher}
                                    handleClassTab={this.handleClassTab}
                                    handleAddStudent={this.handleAddStudent}
                                    handleItemClick={this.handleStudentClick}
                                    deleteStudent={this.props.deleteStudent}
                                />
                            </div>
                        </div>
                    ) :this.state.showPerformance?
                        (
                            <div style={{width:550}}>
                                <ul className="nav nav-tabs">
                                    <li onClick={this.handleStudentsTab}><a data-toggle="tab">Students</a></li>
                                    <li className="active" onClick={this.handlePerformanceTab}><a data-toggle="tab">Game Performance</a></li>
                                </ul>
                                <div className="tab-content" style={{overflow:"scroll"}}>
                                    <GamePerformaceComponent  class={this.state.class} role={"admin"} cancelCallback={this.handleCancel}  />
                                </div>
                            </div>

                        ):
                    (
                        <div>
                            <ul className="nav nav-tabs">
                                <li onClick={this.handleStudentsTab}><a data-toggle="tab">Students</a></li>
                                <li className="active" onClick={this.handleClassTab}><a data-toggle="tab">Class Info</a></li>
                            </ul>
                        </div>
                    )
                }
            </div>
        );
    }
}


class StudentsList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showAddStudentHint:true,
            analytics: {
                type: null,
                metadata: null,
            }}
        this.handleItemClick = this.handleItemClick.bind(this);
        this.handleClassTab = this.handleClassTab.bind(this);
        this.handleAddStudent = this.handleAddStudent.bind(this);
        this.handleAddStudentHint = this.handleAddStudentHint.bind(this);
        this.getTarget = this.getTarget.bind(this);
        this.handleAnalytics = this.handleAnalytics.bind(this);
    }
    componentDidMount(){
        if(localStorage.getItem('addStudent') === 'hide'){
            this.setState({showAddStudentHint: false})
        }
    }
    handleAddStudentHint(){
        this.setState({showAddStudentHint: !this.state.showAddStudentHint})
    }
    getTarget() {
        return ReactDOM.findDOMNode(this.target);
    }

    handleClassTab(event) {
        this.props.handleClassTab();
    }

    handleAnalytics(){
        let analytics = this.state.analytics;
        REST.addAnalytics(analytics).then(res => {});
    }

    handleItemClick = async (student) => {
        await this.setState({
                analytics:{
                    type:TRACKING.TEACHER_STUDENT_DETAILS_VIEW,
                    metadata:{userId: student.userId}
                }
            },
            () => {this.handleAnalytics();this.props.handleItemClick(student, this.props.classId);}  );
    };

    handleAddStudent(event) {
        this.props.handleAddStudent();
        this.handleAddStudentHint();
        localStorage.setItem('addStudent', 'hide');
        event.preventDefault();
    }

    render() {
        const sharedProps = {
            container: this,
            target: this.getTarget,
            show: this.state.showAddStudentHint
        };
        let items = this.props.students;
        let students = items.map((student) => {
            return <StudentListItem key={student.id} student={student} researcher={this.props.researcher} handleClick={this.handleItemClick} deleteStudent={this.props.deleteStudent}/>
        });
        return (
            <div>
                <div className={"row"}>
                    <div className={"col-lg-10 col-md-10 "}>
                    </div>
                    {this.props.researcher?
                    <div className={"col-lg-2 col-md-2 "}>
                        <a ref={button => {
                            this.target = button;
                        }} className="fr">
                            <img src={ico_plus_green} onClick={this.handleAddStudent} style={{cursor:'pointer'}} alt="Plus Icon" border="0" className="ico-xs ico-add" />
                        </a>
                    </div>:null}
                </div>

                <div className="col-lg-12 col-md-12 solidBorder noPadding scrollable" style={{maxHeight:450, height:450}}>
                    <table cellPadding="0" cellSpacing="0" border="0" width="100%">
                        <thead>
                        <tr className="clickable-row">
                            {this.props.researcher?<th>#</th>:null}
                            {this.props.researcher?null:<th>Full Name</th>}
                            <th >User Name</th>
                            {this.props.researcher?<th>Group</th>:null}
                            <th className="fitWidth">Password</th>
                        </tr>
                        </thead>
                        <tbody>
                        {students}
                        </tbody>
                    </table>
                </div>
            </div >
        );
    }
}

class StudentListItem extends Component {
    constructor(props) {
        super(props);
        this.state = {modalDialog:false, responseContent:''}
        this.handleClick = this.handleClick.bind(this);
        this.deleteStudent = this.deleteStudent.bind(this);
    }

    handleClick(event) {
        this.props.handleClick(this.props.student);
        event.stopPropagation();
    }

    deleteStudent = (confirm) => {
        if(confirm) {
            this.props.deleteStudent(this.props.student);
        }
    }

    render() {
        let student = this.props.student;
        return (
            <tr className="clickable-row">
                <DialogBox
                    modalOpen={this.state.modalDialog}
                    confirmDelete={this.deleteStudent}
                    sectionContent={this.state.responseContent}
                    closeClick={(active)=>{this.setState({modalDialog: active});}}
                />
                {this.props.researcher?
                    <td onClick={(event)=>{this.setState({modalDialog:true,responseContent:'ARE YOU SURE YOU WANT TO DELETE THIS STUDENT?'});   event.stopPropagation();}}>
                        <input
                            style={{maxHeight:30}}
                            type="image"
                            alt={"Delete"}
                            src={require("../assets/images/ico-trash.png")}

                        />
                    </td>:
                <td onClick={this.handleClick}>{student.user.firstname} {student.user.lastname}</td>}
                <td onClick={this.handleClick}>{student.user.username}</td>
                {this.props.researcher?
                    <td onClick={this.handleClick}>{student.participant_group.name} </td>
                :null}
                <td onClick={this.handleClick}>{student.user.password}</td>
            </tr>
        )
    }
}

class AddStudentComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            saved: false,
            firstname: '',
            lastname: '',
            email: null,
            username: '',
            gender: null,
            race: null,
            language: null,
            disability: null,
            placement: null,
            gradeLevel: null,
            iep: '-1',
            freeLunch: '-1',
            ell: '-1',
            title1: '-1',
            farms: '-1',
            research: true,
            samplingStrategyId: this.props.samplingStrategyId,
            participantGroupId: null,
            screeningLevel: null,
            firstNameError: '',
            lastNameError: '',
            readingLevelError: '',
            genderError: '',
            raceError: '',
            languageError: '',
            disabilityError: '',
            placementError: '',
            gradeError: '',
            emailWarning: '',
            errorEmail: '',
            errorNote: '',
            apps:"picturenaming,wordsignsay,copyright,slash,kidsign,kidspeak,maze,wordmark",
            excludeVid:false,
            multipleValues: []
        };
        this.handleName = this.handleName.bind(this);
        this.handleLastName = this.handleLastName.bind(this);
        this.handlePassword = this.handlePassword.bind(this);
        this.handleUsername = this.handleUsername.bind(this);
        this.handleEmail = this.handleEmail.bind(this);
        this.handleReadingLevel = this.handleReadingLevel.bind(this);
        this.handleGender = this.handleGender.bind(this);
        this.handleRace = this.handleRace.bind(this);
        this.handleFreeLunch = this.handleFreeLunch.bind(this);
        this.handleELL = this.handleELL.bind(this);
        this.handleIEP = this.handleIEP.bind(this);
        this.handleGrade = this.handleGrade.bind(this);
        this.handleTitle1 = this.handleTitle1.bind(this);
        this.handleFarms = this.handleFarms.bind(this);
        this.handleResearch = this.handleResearch.bind(this);
        // this.handleAppChange = this.handleAppChange.bind(this);

        this.handleSave = this.handleSave.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleAnalytics = this.handleAnalytics.bind(this);

    }

    componentDidMount(){

    }

    handleAnalytics(){
        let analytics = this.state.analytics;
        REST.addAnalytics(analytics).then(res => {});
    }

    handleName(event) {
        this.setState({ firstname: event.target.value.trim() });
    }

    handleLastName(event) {
        this.setState({ lastname: event.target.value.trim() });
    }

    handleUsername(event) {
        this.setState({ username: event.target.value });
    }

    handlePassword(event) {
        this.setState({ password: event.target.value});
    }

    handleEmail(event) {
        this.setState({email: event.target.value});
        if(event.target.value.length === 0){
            this.setState({email: null, errorEmail: '', emailWarning: '' });
        }
        else {
            if (!this.validateEmail(event.target.value)){
                this.setState({errorEmail: 'validationRed', emailWarning: 'Email address format is invalid' });
            }
            else {
                this.setState({email: event.target.value, emailWarning: '', errorEmail: ''});
            }
        }
    }

    handleReadingLevel(event) {
        this.setState({ screeningLevel: event.value });
    }

    handleGender(event) {
        this.setState({ gender: event.value });
    }

    handleGrade(event) {
        this.setState({ gradeLevel: event.value });
    }

    handleRace(event) {
        this.setState({ race: event.value });
    }

    validateEmail(email) {
        let re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }

    validate() {
        let valid = true;
        if (this.state.firstname === '') {
            valid = false;
            this.setState({ firstNameError:'' });
        }
        else {
            this.setState({ firstNameError:''});
        }
        if (this.state.lastname.length === 0){
            valid = false;
            this.setState({ lastNameError:'' });
        }
        else {
            this.setState({ lastNameError:'' });
        }
        if (this.state.username.length === 0){
            valid = false;
            this.setState({ userNameError:'userNameError' });
        }
        else {
            this.setState({ userNameError:'' });
        }
        if(!this.state.email || this.state.email === ''){
            this.setState({email: null, errorEmail: '', emailWarning: '' });
        }
        else {
            if (!this.validateEmail(this.state.email)){
                this.setState({errorEmail: 'validationRed', emailWarning: 'Email address format is invalid' });
                valid = false;
            }
            else {
                this.setState({emailWarning: '', errorEmail: ''});
            }
        }
        return valid;
    }

    handleELL(event) {
        this.setState({ ell: event === null ? '-1' : event.value });
    }

    handleFreeLunch(event) {
        this.setState({ freeLunch: event === null ? '-1' : event.value });
    }

    handleIEP(event) {
        this.setState({ iep: event === null ? '-1' : event.value });
    }

    handleTitle1(event) {
        this.setState({ title1: event === null ? '-1' : event.value });
    }

    handleFarms(event) {
        this.setState({ farms: event === null ? '-1' : event.value });
    }

    handleResearch(event) {
        this.setState({ research: !event.target.checked });
    }

    async handleSave(event) {
        if(!this.state.saved) {
            await this.setState({saved: true});
            if (this.validate()) {
                this.setState({errorNote: ''});

                REST.addNewStudent(this.props.teacherId, this.props.classId, this.props.samplingStrategyId, this.state.participantGroupId, this.state).then(async (response) => {
                    if (response.body.students && response.body.students[0]) {
                        this.setState({
                                saved:false,
                                analytics: {
                                    type: TRACKING.TEACHER_ADD_STUDENT,
                                    metadata: {
                                        userId: response.body.students[0].user.id,
                                        firstName: response.body.students[0].user.firstname,
                                        lastName: response.body.students[0].user.lastname
                                    },
                                }
                            },
                            () => this.handleAnalytics())
                        this.handleCancel();
                    } else {
                        await this.setState({
                            saved: false,
                            modalDialog: true,
                            responseContent: 'Invalid data entered. The email account or username may have been used previously.'
                        });
                    }
                }, async (error) => {
                    await this.setState({
                        saved: false,
                        modalDialog: true,
                        responseContent: 'Error new student.'
                    });
                });

            } else {
                await this.setState({
                    errorNote: 'All fields not labeled "optional" are required!',
                    saved: false
                });
            }
        }
    }

    handleCancel(event) {
        //this.props.handleCancel();
        this.props.handleClassItemClick(this.props.class);
    }

    render() {
        if (!this.props.classId) {
            return <Redirect to="/login" />
        }
        return (
            <div className="col-md-9">
                <DialogBox notificationModal modalOpen={this.state.modalDialog} sectionContent={this.state.responseContent} closeClick={(active)=>{this.setState({modalDialog: active});}} />
                <h1>Add Student</h1>
                <div className="col-lg-12 solidBorder">
                    <div style={{color:'red',paddingLeft:15}}>{this.state.errorNote}</div>
                    <form id="formAddStudent">
                        <div className={"col-md-8 noPaddingLR15"}>
                            <div className="col-sm-6">
                                <label htmlFor="inputStudentName">First Name</label><br/>
                                <input type="text" value={this.state.firstName} onChange={this.handleName} id="inputStudentName" className={this.state.firstNameError + " form-control inputStyle1"} placeholder="First Name" required autoFocus />
                                <label htmlFor="inputStudentLastName">Last Name</label>
                                <input type="text" value={this.state.lastName} onChange={this.handleLastName} id="inputStudentLastName" className={this.state.lastNameError + " form-control inputStyle1"} placeholder="Last Name" required />
                                <label htmlFor="inputStudentUsername">User Name</label>
                                <input type="text" defaultValue={this.state.username} onChange={this.handleUsername} id="inputStudentUsername" maxLength="16" className="form-control inputStyle1" placeholder="User Name"/>
                                <label htmlFor="inputStudentPassword">Password</label>
                                <input type="text" defaultValue={this.state.password} onChange={this.handlePassword} id="inputStudentPassword" maxLength="16" className={this.state.passwordError + " form-control inputStyle1"} placeholder="Password" required />
                                <label htmlFor="inputStudentEmail">Email</label>
                                <input type="text" defaultValue={this.state.email} onChange={this.handleEmail} id="inputStudentEmail" className={this.state.errorEmail + ' form-control inputStyle1'} placeholder="Email" />
                            </div>
                            <div className="col-sm-6">
                                <label htmlFor="inputStudentGender">Gender</label>
                                <Select className={this.state.genderError}  onChange={this.handleGender} id="inputStudentGender" options={genderOptions} isSearchable={false} />
                                <label htmlFor="inputStudentRace">Race and Ethnicity</label>
                                <Select  onChange={this.handleRace} id="inputStudentRace"  defaultValue={getValue(raceOptions, this.state.race)} options={raceOptions} isSearchable={false} />
                                <label htmlFor="inputStudentGrade">Grade Placement</label>
                                <Select className={this.state.gradeError} onChange={this.handleGrade} id="inputStudentGrade" options={gradeOptions} isSearchable={false} />
                                <label htmlFor="inputStudentReadingLevel">Reading Level</label>
                                <Select className={this.state.readingLevelError}  onChange={this.handleReadingLevel} id="inputStudentReadingLevel"  options={readingLevelOptions} isSearchable={false} />
                                <div style={{color:'red'}}>{this.state.emailWarning}</div>
                                {this.props.researcher?
                                    <div>
                                        <label>Research Group</label>
                                        <div>
                                            <Select
                                                id={"updateParticipantGroup"}
                                                onChange={(newValue)=>{this.setState({ participantGroupId: newValue.value})}}
                                                options={this.props.participantGroupOptions}
                                                placeholder = {"Select a group..."}
                                                defaultValue={getValue(this.props.participantGroupOptions, this.state.participantGroupId)}
                                            />
                                        </div>
                                    </div>
                                    :null}
                            </div>
                        </div>
                        <div className="col-sm-4">
                            <label htmlFor="inputStudentIEP">IEP (Optional)</label>
                            <Select  onChange={this.handleIEP} id="inputStudentIEP"  defaultValue={getFourValue(fourValueOptions, this.state.iep)} options={fourValueOptions} isSearchable={false} isClearable={true}/>
                            <label htmlFor="inputStudentELL">ELL (Optional)</label>
                            <Select  onChange={this.handleELL} id="inputStudentELL" defaultValue={getFourValue(fourValueOptions, this.state.ell)} options={fourValueOptions} isSearchable={false} isClearable={true}/>
                            <label htmlFor="inputStudentTitle1">Title 1 (Optional)</label>
                            <Select  onChange={this.handleTitle1} id="inputStudentTitle1"  defaultValue={getFourValue(fourValueOptions, this.state.title1)} options={fourValueOptions} isSearchable={false} isClearable={true}/>
                            <label htmlFor="inputFarms">FARMS (Optional)</label>
                            <Select  onChange={this.handleFarms} id="inputFarms"  defaultValue={getFourValue(fourValueOptions, this.state.farms)} options={fourValueOptions} isSearchable={false} isClearable={true}/><br/>
                            <label htmlFor="Research" className="cb"><input type="checkbox" onChange={this.handleResearch} name="Research" value={!this.state.research} id="Research" /><span className="checkmark"></span> Exclude Student Data</label>

                        </div>
                    </form>
                    <div className="clearfix"></div>
                    <div className="divBottomRelative tr">
                        {/*<p className="text-left">Note: Fields with * are required fields</p>*/}
                        {/*<hr />*/}
                        <a onClick={this.handleCancel} className="handBtn">
                            <span>Cancel</span>
                        </a>
                        <a onClick={() => { this.handleSave() } } className="handBtn">
                            <span>Save Changes</span>
                        </a>
                    </div>
                </div>
            </div >
        )
    }
}
const AddStudent = withRouter(AddStudentComponent);

const bindActionToProps = dispatch => {
    return {
        selectSchool: async(selectedSchool) => await dispatch(selectSchool(selectedSchool)),
        selectTeacher: async(selectedTeacher) => await dispatch(selectTeacher(selectedTeacher)),
        selectClass: async(selectedClass) => await dispatch(selectClass(selectedClass)),
        updateStudent: async(selectedStudent) => await dispatch(updateStudent(selectedStudent)),
        updateTeacher: async(data) => await dispatch(updateTeacher(data)),
        userLogout: async() => await dispatch(userLogout())
    };
};


const mapStateToProps = state => ({
    lastSchool: state.teacherReducer.lastSchool,
    lastTeacher: state.teacherReducer.lastTeacher,
    lastClass: state.teacherReducer.lastClass,
    lastStudent: state.teacherReducer.student,
    teacher: state.teacherReducer.teacher,
    schoolAdmin: state.teacherReducer.schoolAdmin
});


export default connect(mapStateToProps,bindActionToProps)(withRouter(SchoolAdminComponent));